(function () {
	"use strict";
	var $ = avm.require("jquery");

	//$_ refers to jQuery added into Text file (WEBSITE-3647)
	if (typeof $_ !== 'undefined') {
		$ = $_;
	}

	var $btnContactFrom = $('.btn-modal-contactForm'),
		$modal_textForReplace = $('.js-modal-btn-text'),
		$modal_whitepapersButtons = $('.js-modal-whitepapersForm'),
		yt_videoLink = 'https://www.youtube-nocookie.com/embed/g4NxK6yOYkM?controls=0';

	
	// Open contact form modal
	$btnContactFrom.on('click', function () {
		$modal_whitepapersButtons.removeClass('activeLink');
		$('#carriers-contact-form').load('carriers-contact-form', function () {
			initAvastForm();
			$('#carriers-contact-form').siblings().show();
			$('#carriers-contact-form').find('input.button[type="submit"]').removeClass('button blue large').addClass('btn btn-primary btn-lg')
		})
	})

	// Open whitepapers form modals
	$modal_whitepapersButtons.on('click', function (e) {
		$modal_whitepapersButtons.removeClass('activeLink');
		$(this).addClass('activeLink');
		$('#carriers-whitepapers-form').load('carriers-contact-form', function () {
			initAvastForm();
			$('#carriers-whitepapers-form').siblings().show();
			$('#carriers-whitepapers-form').find('input.button[type="submit"]').attr('value', $modal_textForReplace.text()).removeClass('button blue large').addClass('btn btn-primary btn-lg');
		})
	})

	// Contact form after success
	$(document).on('avastform-linear-success', function () {
		initAvastForm();
		if($($modal_whitepapersButtons).hasClass('activeLink')) {
			window.open( $('.js-modal-whitepapersForm.activeLink').attr('href'), '_blank');
			$modal_whitepapersButtons.removeClass('activeLink');
		}
		$('#carriers-whitepapers-form').siblings().hide();
		$('#carriers-contact-form').siblings().hide();
	});

	// Opening Modal with video
	$('.play-button').on('click', function () {
		if ($('#player').attr('src') == yt_videoLink) {

		} else {
			$('#player').attr('src', yt_videoLink);
		}
	});

	// Closing modal
	$('.close').on('click', function () {
		$('#player').attr('src', '');
	});

	$("#modalVideo").on('click', function (e) {
		if (!$(e.target).hasClass('modal-content')) {
			$('#player').attr('src', '');
		}
	})



})();
